import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-788a3947")

_pushScopeId("data-v-788a3947")
const _hoisted_1 = { class: "grid gap-6 grid-cols-5" }
const _hoisted_2 = { class: "flex radio mt-2" }
const _hoisted_3 = {
  for: "scan",
  class: "cursor-pointer"
}
const _hoisted_4 = {
  for: "list",
  class: "cursor-pointer"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-black-lp-300 mt-1"
}
const _hoisted_6 = {
  key: 0,
  id: "filter-list-bkd",
  class: "flex w-full gap-x-4 items-center",
  style: {"margin-bottom":"-24px"}
}
const _hoisted_7 = { class: "w-full flex flex-col py-2" }
const _hoisted_8 = {
  key: 1,
  class: "w-2/12"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_10 = { class: "flex items-end justify-between" }
const _hoisted_11 = { class: "flex gap-x-16" }
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = { class: "font-semibold text-black-lp-300" }
const _hoisted_14 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_15 = { class: "space-y-2" }
const _hoisted_16 = { class: "font-semibold text-black-lp-300" }
const _hoisted_17 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_18 = { class: "space-y-2" }
const _hoisted_19 = { class: "font-semibold text-black-lp-300" }
const _hoisted_20 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = { class: "font-semibold text-black-lp-300" }
const _hoisted_23 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_24 = { class: "flex gap-x-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = {
  class: "px-8 py-4 bg-gray-lp-700",
  style: {"box-shadow":"0px -4px 8px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_28 = { class: "flex items-end justify-between" }
const _hoisted_29 = { class: "flex gap-x-16" }
const _hoisted_30 = { class: "font-semibold text-black-lp-300 text-12px" }
const _hoisted_31 = { class: "font-semibold text-16px text-red-lp-300" }
const _hoisted_32 = { class: "font-semibold text-black-lp-300 text-12px" }
const _hoisted_33 = { class: "font-semibold text-16px text-red-lp-300" }
const _hoisted_34 = { class: "font-semibold text-black-lp-300 text-12px" }
const _hoisted_35 = { class: "font-semibold text-16px text-red-lp-300" }
const _hoisted_36 = { class: "font-semibold text-black-lp-300 text-12px" }
const _hoisted_37 = { class: "font-semibold text-16px text-red-lp-300" }
const _hoisted_38 = { class: "flex gap-x-4" }
const _hoisted_39 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_40 = { class: "hidden" }
const _hoisted_41 = /*#__PURE__*/_createVNode("img", {
  id: "form-pickup-manifest-barcode",
  alt: "barcode"
}, null, -1)
const _hoisted_42 = { class: "flex-col grid col-gap-2 grid-cols-8 justify-center w-full mt-2" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_44 = { class: "col-span-4 space-y-1" }
const _hoisted_45 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_46 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_47 = { class: "text-12px text-black-lp-300" }
const _hoisted_48 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_50 = { class: "text-12px text-black-lp-300" }
const _hoisted_51 = { class: "flex flex-row" }
const _hoisted_52 = { class: "flex flex-col space-y-3" }
const _hoisted_53 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_54 = { class: "space-y-1" }
const _hoisted_55 = { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }
const _hoisted_56 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_57 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_58 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "check-circle"
}, null, -1)
const _hoisted_59 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_60 = { class: "flex justify-end space-x-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.$t('Buat Pickup Manifest'),
      "vertical-separator": false,
      fullPage: "",
      isFloatingAction: true
    }, _createSlots({
      data: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('Kota Asal')
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.originCity
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('Nama POS')
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.namePOS
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('Tanggal Pickup'),
            class: "col-span-2"
          }, {
            default: _withId(() => [
              _createVNode(_component_Datepicker, {
                class: "mt-1.5",
                disabled: "",
                modelValue: _ctx.form.pickupDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.pickupDate = $event)),
                placeholder: _ctx.$t('pickupManifest.placeholderPickupDate')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2 hidden",
            label: _ctx.$t('Diserahkan ke')
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                serverSide: false,
                class: "mt-1.5",
                options: _ctx.handoverOptions,
                keyName: "name",
                keyValue: "id",
                modelValue: _ctx.form.handoverName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.handoverName = $event)),
                placeholder: _ctx.$t('Pilih vendor atau partner')
              }, null, 8, ["options", "modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('Nama Driver')
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                "onSubmit:driver": _ctx.onCreatedDriver,
                addDriver: true,
                serverSide: false,
                class: "mt-1.5",
                options: _ctx.driverOptions,
                keyName: "driverInfo",
                keyValue: "driverId",
                modelValue: _ctx.form.driverName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.driverName = $event)),
                placeholder: _ctx.$t('Pilih atau masukan nama driver')
              }, null, 8, ["onSubmit:driver", "options", "modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('No. Seri Kendaraan')
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                "onSubmit:licensePlate": _ctx.onCreatedLicensePlate,
                addLicensePlate: true,
                serverSide: true,
                class: "mt-1.5",
                onFilter: _ctx.fetchVehicles,
                isLoading: _ctx.isLoading,
                options: _ctx.licensePlateOptions,
                keyName: "name",
                keyValue: "name",
                modelValue: _ctx.form.licensePlate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.licensePlate = $event)),
                placeholder: _ctx.$t('Pilih atau masukan No. seri kendaraan')
              }, null, 8, ["onSubmit:licensePlate", "onFilter", "isLoading", "options", "modelValue", "placeholder"]),
              _withDirectives(_createVNode("p", { class: "text-red-lp-100 mt-2" }, _toDisplayString(_ctx.$t("Data Kendaraan sudah ada")), 513), [
                [_vShow, _ctx.isError]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-4",
            label: _ctx.$t('pickupManifest.inputSttLabel')
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", {
                  class: "flex gap-x-2",
                  style: {"margin-right":"78px"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeRadio('scan')))
                }, [
                  _createVNode(_component_RadioButton, {
                    id: "scan",
                    name: "Scan Stt",
                    value: "scan",
                    modelValue: _ctx.inputSttRadioValue,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.inputSttRadioValue = $event)),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeRadio('scan')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("pickupManifest.scanStt")), 1)
                ]),
                _createVNode("div", {
                  class: "flex gap-x-2",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeRadio('list')))
                }, [
                  _createVNode(_component_RadioButton, {
                    id: "list",
                    name: "List BKD",
                    value: "list",
                    modelValue: _ctx.inputSttRadioValue,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputSttRadioValue = $event)),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeRadio('list')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("pickupManifest.listBkd")), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.inputSttRadioValue === 'scan')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "col-span-4",
                label: _ctx.$t('No. STT')
              }, {
                default: _withId(() => [
                  _createVNode(_component_LpInput, {
                    ref: "inputStt",
                    onEnter: _ctx.onValidateSttNumber,
                    onChange: _ctx.onChangeInputStt,
                    sizeInput: "24px",
                    bold: "",
                    labelStacked: _ctx.$t('pickupManifest.exampleStt'),
                    modelValue: _ctx.form.sttNumber,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.sttNumber = $event)),
                    placeholder: _ctx.$t('Masukan No. STT atau Scan Barcode/QR Code')
                  }, null, 8, ["onEnter", "onChange", "labelStacked", "modelValue", "placeholder"]),
                  (!_ctx.isPaid)
                    ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t(
                "*Terjadi kelebihan berat sehingga customers perlu menyelesaikan tagihan kurang bayar"
              )), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.inputSttRadioValue === 'list')
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_Search, {
                onInput: _ctx.onSearch,
                onClear: _ctx.clearSearch,
                value: _ctx.searchValue,
                placeholder: _ctx.$t('placeholderSTTColumn'),
                class: "w-52",
                style: {"margin":"0"}
              }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
              _createVNode(_component_CustomDropdown, {
                isExpand: _ctx.isProductExpand,
                "onUpdate:isExpand": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isProductExpand = $event)),
                placeholder: _ctx.$t('shipmentRates.detailRates.product'),
                value: _ctx.$t('Produk'),
                style: _ctx.isProductExpand ? 'width: 304px;' : '',
                counter: _ctx.selectedProduct.length,
                isCustomWidth: ""
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_7, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: ["p-field-checkbox checkbox relative flex items-center", index === 0 ? '' : 'mt-4']
                      }, [
                        _createVNode(_component_Checkbox, {
                          name: "product",
                          id: index,
                          value: product.code,
                          modelValue: _ctx.selectedProduct,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedProduct = $event))
                        }, null, 8, ["id", "value", "modelValue"]),
                        _createVNode("label", {
                          for: `${index}`,
                          class: "ml-2.5"
                        }, _toDisplayString(product.name), 9, ["for"])
                      ], 2))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["isExpand", "placeholder", "value", "style", "counter"]),
              _createVNode(_component_CustomDropdown, {
                options: _ctx.sortOptions,
                placeholder: _ctx.$t('Urutkan'),
                value: _ctx.sortSelected.name || _ctx.$t('Urutkan'),
                class: "w-36",
                isCustomWidth: "",
                isCheck: "",
                selectedItem: _ctx.sortSelected,
                "onUpdate:selectedItem": _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortSelected = $event))
              }, null, 8, ["options", "placeholder", "value", "selectedItem"]),
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.periodeStart,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.periodeStart = $event)),
                minDate: _ctx.minDatePeriodeStart,
                style: {"margin":"0"}
              }, null, 8, ["modelValue", "minDate"]),
              _createVNode(_component_LpButton, {
                onClick: _ctx.onGetListBkd,
                title: _ctx.$t('Cari'),
                disabled: _ctx.isDisabledSearchButton,
                textColor: "red-lp-100",
                color: "red-lp-100",
                customClass: "px-12",
                outline: ""
              }, null, 8, ["onClick", "title", "disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.inputSttRadioValue === 'scan')
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_LpButton, {
                onClick: _ctx.addSttNumber,
                customClass: "px-12 py-2.5",
                title: _ctx.$t('Tambah'),
                disabled: _ctx.isDisabled,
                textColor: "white"
              }, null, 8, ["onClick", "title", "disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataSttToBePickup.length > 0 && _ctx.inputSttRadioValue === 'scan')
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Total STT")), 1),
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.totalStt), 1)
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Total Koli")), 1),
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.totalPieces), 1)
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("Total Berat Kotor")), 1),
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.isValueDecimal(_ctx.convertTotalKg(_ctx.totalGrossWeight))) + " Kg ", 1)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("Total Berat Dimensi")), 1),
                    _createVNode("div", _hoisted_23, _toDisplayString(_ctx.isValueDecimal(_ctx.convertTotalKg(_ctx.totalVolumeWeight))) + " Kg ", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode(_component_LpButton, {
                    outline: "",
                    onClick: _ctx.onShowDelete,
                    iconLeft: "delete",
                    title: _ctx.$t('Hapus'),
                    textColor: "red-lp-300"
                  }, null, 8, ["onClick", "title"]),
                  _createVNode(_component_LpButton, {
                    onClick: _ctx.togglePanel,
                    icon: 
                _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
              ,
                    title: _ctx.$t('Process'),
                    textColor: "white"
                  }, null, 8, ["onClick", "icon", "title"]),
                  _createVNode(_component_OverlayPanel, {
                    ref: "op",
                    appendTo: "body",
                    style: {"width":"auto"}
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_LpButton, {
                        class: "w-60",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.pickupAndPrint(false))),
                        flat: "",
                        dense: "",
                        iconLeft: "truck-pickup",
                        title: _ctx.$t('Buat Pickup')
                      }, null, 8, ["title"]),
                      _hoisted_25,
                      _createVNode(_component_LpButton, {
                        class: "w-60",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.pickupAndPrint(true))),
                        flat: "",
                        dense: "",
                        iconLeft: "printer",
                        title: _ctx.$t('pickupManifest.buatPickupPrintPdf')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_TableV2, {
                  data: _ctx.dataSttToBePickup,
                  columns: _ctx.columns,
                  borderTop: false,
                  pagination: _ctx.pagination,
                  "is-hard-pagination": true,
                  "is-quick-search": true,
                  "is-sorting": true,
                  "pagination-style": "v2"
                }, null, 8, ["data", "columns", "pagination"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLoadingListBkd)
          ? (_openBlock(), _createBlock(_component_Loading, {
              key: 3,
              modelValue: _ctx.isLoadingListBkd,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.isLoadingListBkd = $event)),
              class: "mt-6",
              isModal: false
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (
          _ctx.inputSttRadioValue === 'list' &&
            !_ctx.isLoadingListBkd &&
            (_ctx.listBkd?.length > 0 || _ctx.errorCauseListBkd)
        )
          ? (_openBlock(), _createBlock(_component_TableV2, {
              key: 4,
              data: _ctx.filteredListBkd,
              errorCause: _ctx.errorCauseListBkd,
              columns: _ctx.columns,
              borderTop: false,
              hidePagination: true,
              isCheckBox: true,
              isDownloadCheckBox: false,
              checkedData: _ctx.sourceSttBkdListFromLocalStorage,
              "onUpdate:checkedData": _cache[19] || (_cache[19] = ($event: any) => (_ctx.sourceSttBkdListFromLocalStorage = $event))
            }, null, 8, ["data", "errorCause", "columns", "checkedData"]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          style: 
          `margin-bottom: ${
            _ctx.inputSttRadioValue === 'list' &&
            !_ctx.isLoadingListBkd &&
            !(_ctx.listBkd?.length > 0 || _ctx.errorCauseListBkd)
              ? '18'
              : '2'
          }rem`
        
        }, null, 4)
      ]),
      _: 2
    }, [
      (_ctx.inputSttRadioValue === 'list' && _ctx.listBkd?.length > 0)
        ? {
            name: "floating-footer",
            fn: _withId(() => [
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("Total STT")), 1),
                      _createVNode("div", _hoisted_31, _toDisplayString(_ctx.totalStt), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("Total Koli")), 1),
                      _createVNode("div", _hoisted_33, _toDisplayString(_ctx.totalPieces), 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("Total Berat Kotor")), 1),
                      _createVNode("div", _hoisted_35, _toDisplayString(_ctx.isValueDecimal(_ctx.convertTotalKg(_ctx.totalGrossWeight))) + " Kg ", 1)
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("Total Berat Dimensi")), 1),
                      _createVNode("div", _hoisted_37, _toDisplayString(_ctx.isValueDecimal(_ctx.convertTotalKg(_ctx.totalVolumeWeight))) + " Kg ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _createVNode(_component_LpButton, {
                      onClick: _cache[20] || (_cache[20] = 
                e => (_ctx.dataSttToBePickup.length === 0 ? null : _ctx.togglePanel(e))
              ),
                      icon: 
                _ctx.$refs.op?.visible ? 'chevron-down-white' : 'chevron-up-white'
              ,
                      title: _ctx.$t('Process'),
                      textColor: "white",
                      disabled: _ctx.dataSttToBePickup.length === 0
                    }, null, 8, ["icon", "title", "disabled"]),
                    _createVNode(_component_OverlayPanel, {
                      ref: "op",
                      appendTo: "body",
                      style: {"width":"auto"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_LpButton, {
                          class: "w-60",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.pickupAndPrint(false))),
                          flat: "",
                          dense: "",
                          iconLeft: "truck-pickup",
                          title: _ctx.$t('Buat Pickup')
                        }, null, 8, ["title"]),
                        _hoisted_39,
                        _createVNode(_component_LpButton, {
                          class: "w-60",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.pickupAndPrint(true))),
                          flat: "",
                          dense: "",
                          iconLeft: "printer",
                          title: _ctx.$t('pickupManifest.buatPickupPrintPdf')
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])
              ])
            ])
          }
        : undefined
    ]), 1032, ["onBack", "title"]),
    _createVNode("div", _hoisted_40, [
      _createVNode("img", {
        id: "logo-receipt",
        src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
        alt: "logo"
      }, null, 8, ["src"]),
      _hoisted_41
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.alertPopup.message,
      image: _ctx.alertPopup.image,
      textSuccess: 
      _ctx.isPartial || _ctx.isFailed
        ? _ctx.$t('pickupManifest.download')
        : _ctx.$t('pickupManifest.ok')
    ,
      textCancel: _ctx.isPartial || _ctx.isFailed ? _ctx.$t('pickupManifest.ok') : '',
      class: "px-8",
      customButton: _ctx.isPartial || _ctx.isFailed ? 'px-10' : 'px-6'
    }, {
      custom: _withId(() => [
        _createVNode("div", _hoisted_42, [
          _hoisted_43,
          _createVNode("div", _hoisted_44, [
            _withDirectives(_createVNode("div", _hoisted_45, [
              _hoisted_46,
              _createVNode("div", _hoisted_47, _toDisplayString(_ctx.countSuccess) + " " + _toDisplayString(_ctx.$t("No. STT Sukses")), 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_48, [
              _hoisted_49,
              _createVNode("div", _hoisted_50, _toDisplayString(_ctx.countFailed) + " " + _toDisplayString(_ctx.$t("No. STT Gagal")), 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, 
      _ctx.openSuccess ||
        _ctx.isErrorTyping ||
        _ctx.isFailed ||
        _ctx.isPartial ||
        _ctx.isErrorValidationScan
    ]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin ingin keluar?'),
      message: 
      _ctx.$t(
        'Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.'
      )
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali')
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: _ctx.$t('pickup.confirmTitleCreate'),
      message: 
      _ctx.$t('Pastikan kembali, seluruh detail STT sudah benar dan sesuai.')
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('pickup.confirmTextSuccess'),
      textCancel: _ctx.$t('Kembali')
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    (_ctx.isErrorPickup)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCausePickup,
          onCancel: _ctx.closeModalErrorPickup,
          onTryAgain: _ctx.onSave,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Notification, {
      data: _ctx.detailSttNotification,
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.notification = $event))
    }, null, 8, ["data", "modelValue"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true,
      onReset: _ctx.onCloseDelete
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_51, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "delete"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_52, [
            _createVNode("div", _hoisted_53, _toDisplayString(_ctx.$t("Hapus Barang")), 1),
            _createVNode("div", _hoisted_54, [
              _withDirectives(_createVNode("div", _hoisted_55, null, 512), [
                [_directive_sanitize_html, 
              _ctx.$t(
                'Masukan No. STT atau Scan Barcode/QR Code untuk<br/>barang yang ingin dihapus dari daftar Pickup.'
              )
            ]
              ]),
              _createVNode(_component_LpInput, {
                error: _ctx.errorSttNumberDelete !== '',
                errorCaption: _ctx.errorSttNumberDelete,
                onEnter: _ctx.onScanSttNumberToDelete,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.sttNumberToDelete = $event)),
                ref: "deleteStt"
              }, null, 8, ["error", "errorCaption", "onEnter", "modelValue"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_56, [
                  _createVNode("div", _hoisted_57, _toDisplayString(_ctx.$t("Terhapus")), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_58,
                      _createVNode("div", _hoisted_59, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_60, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseDelete,
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('Batal'),
            class: "mt-10"
          }, null, 8, ["onClick", "title"]),
          _createVNode(_component_LpButton, {
            disabled: _ctx.sttNumberToDelete === '',
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('Hapus'),
            class: "mt-10"
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onReset"])
  ], 64))
})